<script>
import IntroContents from '@/components/Peer/IntroContents.vue';

export default {
  components: {
    IntroContents,
  },
};
</script>

<template>
  <div>
    <h2>{{ $t('PEER.Intro.title') }}</h2>
    <br />
    <IntroContents />
  </div>
</template>
